import React, { useEffect, useMemo, useState } from "react"
import PropTypes from "prop-types"
import resolverImagemPerfil from "../../helpers/resolverImagemPerfil"
import obterIniciaisDoNome from "../../helpers/obterIniciaisDoNome"

const AvatarPerfilUsuario = ({ user, className }) => {
  const [lErroCarregarImagem, setErroCarregarImagem] = useState(false)

  const { cUrlImagem, cTextoAvatar } = useMemo(
    () => resolverImagemPerfil(user?.imagemPerfil),
    [user?.imagemPerfil],
  )

  const cTextoExibir = useMemo(
    () => user?.nomeAbreviacao || cTextoAvatar || obterIniciaisDoNome(user?.name),
    [user?.nomeAbreviacao, cTextoAvatar, user?.name],
  )

  useEffect(() => {
    setErroCarregarImagem(false)
  }, [cUrlImagem])

  const lExibirImagem = Boolean(cUrlImagem) && !lErroCarregarImagem

  return (
    <div
      className={className}
      style={
        lExibirImagem
          ? {
              padding: 0,
              overflow: "hidden",
            }
          : undefined
      }
    >
      {lExibirImagem ? (
        <img
          src={cUrlImagem}
          alt={user?.name || "Perfil"}
          onError={() => setErroCarregarImagem(true)}
          style={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
            borderRadius: "50%",
            display: "block",
          }}
        />
      ) : (
        cTextoExibir
      )}
    </div>
  )
}

AvatarPerfilUsuario.propTypes = {
  user: PropTypes.shape({
    name: PropTypes.string,
    nomeAbreviacao: PropTypes.string,
    imagemPerfil: PropTypes.string,
  }),
  className: PropTypes.string,
}

export default AvatarPerfilUsuario
